import axios from 'axios';
import React, {useState,useEffect} from 'react';


//components
import EntertainmentCardSlider from '../components/Entertainment/Entertainmentcard.component';
import PosterSlider from '../components/PosterSlider/PosterSlider.component';

 


//config
import TempPosters from "../config/TempPosters.config";

const HomePage = () => {
  const [popularMovies, setPopularMovies] = useState([]);
  const [topratedrMovies, setTopRatedMovies] = useState([]);
  const [upcomingMovies, setUpcomingMovies] = useState([]);

  useEffect(()=>{
    const requestPopularMovies = async() =>{
      const getPopularMovies = await axios.get("/movie/popular");
      setPopularMovies(getPopularMovies.data.results);
    };
    requestPopularMovies();

    const requestTopRatedMovies = async() =>{
      const getTopRatedMovies = await axios.get("/movie/top_rated");
      setTopRatedMovies(getTopRatedMovies.data.results);
    };
    requestTopRatedMovies();

    const requestUpcomingMovies = async() =>{
      const getUpcomingMovies = await axios.get("/movie/upcoming");
      setUpcomingMovies(getUpcomingMovies.data.results);
    };
    requestUpcomingMovies();

  },[]);
  console.log({popularMovies,topratedrMovies,upcomingMovies});
    return (
        <>
        <div className="flex flex-col gap-10">
        <div className="container mx-auto px-4">
            <h1 className="text-xl font-bold text-gray-800 my-3">The Best of Entertainment</h1>
           <EntertainmentCardSlider />
            </div>
           <div className="bg-prem-600 py-12">
          <div className="container mx-auto px-4 flex flex-col gap-3" >  
          
            <div className="hidden  md:flex  ">
              
                    <img className="w-full h-full" src="https://in.bmscdn.com/discovery-catalog/collections/tr:w-1440,h-120/premiere-rupay-banner-web-collection-202104230555.png" alt="rupay" />
              
                

            </div>
              <PosterSlider images={popularMovies} title="Premieres" subtitle="Brand new releases every Friday" isDark />
          </div>
        </div>
        
           

        </div>
        <div className="container mx-auto px-4 my-8  ">
        <PosterSlider images={topratedrMovies} title="Online streaming Events" isDark={false} /></div>
        <div className="container mx-auto px-4 my-8 ">
        <PosterSlider images={upcomingMovies} title="Outdoor Events" isDark={false}  />


        </div>
           
        </>
    );
};

export default HomePage;
